var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 91 91",
    height: "91px",
    id: "Layer_1",
    viewBox: "0 0 91 91",
    width: "91px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.264,40.626c0-6.208-5.053-11.259-11.262-11.259c-6.209,0-11.262,5.051-11.262,11.259   c0,6.21,5.053,11.263,11.262,11.263C52.211,51.889,57.264,46.836,57.264,40.626z M38.14,40.626c0-4.333,3.527-7.859,7.862-7.859   s7.861,3.525,7.861,7.859c0,4.335-3.526,7.862-7.861,7.862S38.14,44.961,38.14,40.626z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,76.234l1.225-1.271c0.857-0.892,21.017-21.952,21.017-33.845c0-12.264-9.978-22.242-22.241-22.242   c-12.262,0-22.238,9.978-22.238,22.242c0,11.893,20.156,32.953,21.014,33.844L46,76.234z M46,22.278   c10.389,0,18.841,8.452,18.841,18.841c0,8.156-12.622,23.473-18.841,30.188c-6.218-6.713-18.838-22.025-18.838-30.188   C27.162,30.73,35.613,22.278,46,22.278z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.465a79c78fd01b25d7cb3c067a56062a.svg";
export { ForwardRef as ReactComponent };